module.exports = __webpack_public_path__ + "img/gamesdk7.79e7e19.png";